module.exports = __webpack_public_path__ + "img/Rectangle.9cb66eed.png";